<template>
    <div ref="revokeAllBlock" class="row">
        <div class="col-sm-12 mb-3" >
            <div class="d-flex flex-column gap-3 text-center align-items-center">
	            <i class="bi w-auto h-auto fs-large bi-shield-fill-minus"></i>
                <h3 class="fw-semi-bold m-0">Revoke Access Everywhere</h3>
                <p class="text-secondary m-0">Are you sure you want to revoke access for all the active sessions except current session.</p>
	            <p class="text-secondary m-0">Trusted Device status will be removed and you will be logged out from everywhere and will need to login again.</p>
            </div>
        </div>

        <div class="col-12">
            <div class="d-flex flex-row align-items-center justify-content-center gap-3 text-center ">
                <button class="btn btn-outline-secondary rounded-pill py-2 px-3" @click="close">Cancel</button>
                <button class="btn btn-dark rounded-pill py-2 px-3" @click="revokeAll">Yes, Revoke All</button>
            </div>
        </div>
    </div>

</template>

<script setup>
import { watch, ref } from "vue";
import {useAppHelpers} from "@/composables/useAppHelpers.js";
import { useAuthStore } from "@/stores/auth-store.js";
import { useToast } from "@/composables/useToast.js";
import apiClient from "@/utils/axios.js";

const emits = defineEmits(['closeRevokeAll']);

const auth = useAuthStore();
const helper = useAppHelpers();
const { displayToast } = useToast();

const revokeAllBlock = ref(null);

const user = ref(auth.user);
watch(() => auth.user, (newVal) => {
	user.value = newVal;
});

const revokeAll = async () => {
	try{
		helper.loaderOn(revokeAllBlock.value);
		const response = await apiClient.post('/auth/user/trusted-devices/revoke', {
			session_id: 'all'
		});

		if(response.status >= 200 && response.status < 300){
			await close();
		}
		helper.loaderOff(revokeAllBlock.value);
	}
	catch (error) {
		helper.loaderOff(revokeAllBlock.value);
	}
}

const close = async () => {
	emits('closeRevokeAll');
}

defineExpose({
    close
});
</script>
